import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';
import { articleService, IArticle } from '../../services/articleService';
import StoryCard from '../../components/editorial/StoryCard';
interface WriterProfile { id: string; username: string; first_name?: string; last_name?: string; bio?: string; website?: string; twitter?: string; linkedin?: string; }
const WriterProfilePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [writer, setWriter] = useState<WriterProfile | null>(null);
  const [articles, setArticles] = useState<IArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [articlesError, setArticlesError] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true); setWriter(null); setArticles([]); setArticlesError(false);
    const load = async () => {
      try {
        if (!id) return;
        const { data, error } = await supabase.from('profiles').select('*').eq('id', id).single();
        if (error) throw error;
        if (active) setWriter(data);
        try {
          const stories = await articleService.getByAuthor(id);
          if (active) setArticles(stories.filter(article => article.status === 'published'));
        } catch { if (active) setArticlesError(true); }
      } catch { if (active) setWriter(null); }
      finally { if (active) setLoading(false); }
    };
    load();
    return () => { active = false; };
  }, [id]);
  if (loading) return <div className="editorial-shell editorial-empty" role="status">Loading writer…</div>;
  if (!writer) return <div className="editorial-shell editorial-empty">Writer not found.<br /><Link to="/authors" className="editorial-link">Our writers ↗</Link></div>;
  const name = [writer.first_name, writer.last_name].filter(Boolean).join(' ') || writer.username;
  return <div className="editorial-shell archive-page"><header className="writer-heading"><h1>{name}</h1>{writer.bio && <p>{writer.bio}</p>}<div className="writer-links">{writer.website && <a href={writer.website} target="_blank" rel="noopener noreferrer">Website ↗</a>}{writer.twitter && <a href={`https://twitter.com/${writer.twitter.replace('@','')}`} target="_blank" rel="noopener noreferrer">X ↗</a>}{writer.linkedin && <a href={writer.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn ↗</a>}</div></header><div className="section-heading"><h2>Selected stories</h2><span>{articles.length} published</span></div>{articlesError ? <div className="editorial-empty">Unable to load stories right now.</div> : articles.length ? <div className="story-grid">{articles.map((article,index) => <StoryCard key={article.id} article={article} index={index} />)}</div> : <div className="editorial-empty">New stories are on their way.</div>}</div>;
};
export default WriterProfilePage;
